
import { Header } from "@/components/quiz/explainers/header";
import { Button } from "@workspace/ui/components/button";
import Image from "next/image";

export function FertilityJourneyExplainer({
  title,
  description,
  backgroundImage,
  image_description,
  handleNext,
}: {
  title: string;
  description: string;
  backgroundImage: string;
  image_description: string;
  handleNext: () => void;
}) {
  return (
    <>
      <div className="flex flex-1 flex-col gap-6 overflow-y-auto min-h-0 relative pb-12">
        <Header title={title} description={description} />
        <div className="relative">
          <Image
            src={backgroundImage}
            alt={image_description}
            width={1000}
            height={1000}
          />
          <div
            className="text-white title-16 md:title-17 px-6 py-4 text-center absolute bottom-0 left-0"
            dangerouslySetInnerHTML={{ __html: image_description }}
            id="hint-text"
            data-testid="hint-text"
          />
        </div>
      </div>
      <div className="sticky bottom-0 flex flex-col gap-3 pb-6">
       <Button onClick={handleNext} variant="default" className="relative shrink-0">Next</Button>
      </div>
    </>
  );
}
